import { useEffect } from 'react';

import { Footer, Header, pages } from './components/Chrome';
import { useRoute } from './router';
import Company from './pages/Company';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Products from './pages/Products';
import Resources from './pages/Resources';
import SignUp from './pages/SignUp';
import Solutions from './pages/Solutions';

const titles: Record<string, string> = {
  '/': 'ClientMa — business applications from SJS Tech',
  '/products': 'Applications — ClientMa',
  '/solutions': 'Solutions — ClientMa',
  '/pricing': 'Pricing — ClientMa',
  '/resources': 'Resources — ClientMa',
  '/company': 'SJS Tech — ClientMa',
  '/signup': 'Create your account — ClientMa',
};

export default function SiteApp() {
  const [path, navigate] = useRoute();

  // /signup is a real page that is deliberately absent from the menu — it is reached from a
  // call to action, not browsed to.
  const known = pages.some((page) => page.path === path) || path === '/signup';

  // The tab is the only place a person can tell one page from another once they have three of
  // them open.
  useEffect(() => {
    document.title = titles[path] ?? 'ClientMa';
  }, [path]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <Header path={path} navigate={navigate} />

      <main id="main">
        {path === '/' && <Home navigate={navigate} />}
        {path === '/products' && <Products navigate={navigate} />}
        {path === '/solutions' && <Solutions navigate={navigate} />}
        {path === '/pricing' && <Pricing navigate={navigate} />}
        {path === '/resources' && <Resources />}
        {path === '/company' && <Company />}
        {path === '/signup' && <SignUp navigate={navigate} />}

        {!known && (
          <section className="section">
            <div className="wrap" style={{ maxWidth: 640 }}>
              <span className="eyebrow">404</span>
              <h1 style={{ marginBottom: 16 }}>That page is not here</h1>
              <p style={{ color: 'var(--muted)' }}>
                The address may have changed, or it may never have existed. Everything the site
                has is reachable from the menu above.
              </p>
              <p style={{ marginTop: 24 }}>
                <a className="btn btn--primary" href="/">
                  Back to the home page
                </a>
              </p>
            </div>
          </section>
        )}
      </main>

      <Footer navigate={navigate} />
    </>
  );
}
